
import SessionTimesHero from './components/SessionTimesHero';
import WeeklySchedule from './components/WeeklySchedule';
import AgeGroupSchedule from './components/AgeGroupSchedule';
import BookingSection from './components/BookingSection';
import SpecialPrograms from './components/SpecialPrograms';

const SessionTimes = () => {
  return (
    <div className="min-h-screen">
      <SessionTimesHero />
      <WeeklySchedule />
      <AgeGroupSchedule />
      <SpecialPrograms />
      <BookingSection />
    </div>
  );
};

export default SessionTimes;
